import React from "react";
import { useTranslation } from "react-i18next";

interface IServerSettings {
  serverAddress: string;
  serverPort: number;
  serverPath: string;
  keepAliveIntervalMs: number;
  serverTimeoutMs: number;
  bmsPort: string;
  gpsPort: string;
  gpsBaudRate: number;
}

interface IServerSettingsProps {
  settings: IServerSettings | null;
  saveAddress: (value: string) => void;
  savePort: (value: string) => void;
  savePath: (value: string) => void;
  saveKeepAlive: (value: string) => void;
  saveTimeout: (value: string) => void;
  saveBMSPort: (value: string) => void;
  saveGPSPort: (value: string) => void;
  saveGPSRate: (value: string) => void;
  manageConnectionGateways?: boolean;
  saveManageGateways: (value: boolean) => void;
}

const ServerSettings: React.FC<IServerSettingsProps> = ({
  settings,
  saveAddress,
  savePort,
  savePath,
  saveKeepAlive,
  saveTimeout,
  saveBMSPort,
  saveGPSPort,
  saveGPSRate,
  manageConnectionGateways,
  saveManageGateways,
}) => {
  const { t } = useTranslation();
  if (!settings) return null;

  return (
    <div className="p-20">
      <div className="form-wrapper settings-form">
        <div className="input-wrapper input-wrapper-checkbox">
          <input
            type="checkbox"
            id="connection"
            checked={manageConnectionGateways}
            onChange={(event) => saveManageGateways(event.target.checked)}
          />

          <label htmlFor="connection">
            {t("serverSettings.labels.enableAutoSwitch")}
          </label>
        </div>

        <div className="input-wrapper">
          <label>{t("serverSettings.labels.serverAddress")}</label>
          <input
            type="text"
            value={settings.serverAddress}
            onChange={(e) => saveAddress(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.serverPort")}</label>
          <input
            type="text"
            value={settings.serverPort}
            onChange={(e) => savePort(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.apiPath")}</label>
          <input
            type="text"
            value={settings.serverPath}
            onChange={(e) => savePath(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.pingInterval")}</label>
          <input
            type="text"
            value={settings.keepAliveIntervalMs}
            onChange={(e) => saveKeepAlive(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.serverTimeout")}</label>
          <input
            type="text"
            value={settings.serverTimeoutMs}
            onChange={(e) => saveTimeout(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.bmsPort")}</label>
          <input
            type="text"
            value={settings.bmsPort}
            onChange={(e) => saveBMSPort(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.gpsPort")}</label>
          <input
            type="text"
            value={settings.gpsPort}
            onChange={(e) => saveGPSPort(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label>{t("serverSettings.labels.gpsSpeed")}</label>
          <input
            type="text"
            value={settings.gpsBaudRate}
            onChange={(e) => saveGPSRate(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default ServerSettings;
